<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Icon" prop="iconUrl" >
        <file-upload
          :value="form.iconUrl || ''"
          type="image"
          :count="1"
          field-name="iconUrl"
          @change="handleIconChange"
        />
      </a-form-model-item>
      <a-form-model-item label="Infrastructure Name" prop="title" >
        <a-input v-model="form.title" placeholder="Please enter infrastructure name" />
      </a-form-model-item>
      <a-form-model-item label="Enabled" prop="isOpen" >
        <a-select
          v-model="form.isOpen"
          placeholder="Please select"
          allow-clear
          style="width: 100%"
        >
          <a-select-option :value="0">No</a-select-option>
          <a-select-option :value="1">Yes</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item label="Remark" prop="remark" >
        <a-input v-model="form.remark" placeholder="Please enter content" type="textarea" allow-clear />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInfrastructure, addInfrastructure, updateInfrastructure } from '@/api/golf/infrastructure'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,

        iconUrl: null,

        title: null,

        isOpen: null,

        createTime: null,

        remark: null

      },
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        iconUrl: null,
        title: null,
        isOpen: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getInfrastructure({ id: id }).then(response => {
        this.form = response.data
        if (this.form.isOpen !== null && this.form.isOpen !== undefined) {
          this.form.isOpen = Number(this.form.isOpen)
        }
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    handleIconChange (payload) {
      if (typeof payload === 'string') {
        this.form.iconUrl = payload || null
      } else if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'iconUrl')) {
        this.form.iconUrl = payload.iconUrl || null
      }
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateInfrastructure(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addInfrastructure(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
